import React, {useContext} from 'react'
import {Button, Popconfirm} from "antd";
import {OfferContext} from "../../../context/OfferContext";
import {removeIndexAt} from "../../../utils/helpers/commonFunctions";

const OfferCreateActions = ({rowIndex, record}) => {

    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    const handleDeleteClick = () => {
        let mockContext = [...materials]
        const removedList = removeIndexAt(
            mockContext,
            rowIndex
        )
        setMaterials(removedList)
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default OfferCreateActions